

import React from "react";
import sampleImage7 from "../../styles/images/samples/sample_7.jpg";
import ContentSlide2 from "./contentSlide2";

const Main: React.FC = () => {
  return (
    <view data-vertical=""  >
      <view data-direction="row">

        <view data-align="start" data-direction="row" data-space="20" data-gap="20">
          <view data-scroll="">
            <group
              data-align="center"
              data-gap="5"
              data-elevation="1"
              data-index="2"
              data-backdrop=""
              data-wrap="no"
              data-sticky="top"

            >

            </group>
            <group data-height="autofit">
              <picture data-position="absolute" data-object-fit='cover'><img src={sampleImage7} alt="" /></picture>
              <group data-direction="column" data-justify="center" data-align="center" data-space="80">
                <ContentSlide2></ContentSlide2>
              </group>
            </group>
          </view>
          <view data-scroll="">
            <group
              data-align="center"
              data-gap="5"
              data-elevation="1"
              data-index="2"
              data-backdrop=""
              data-wrap="no"
              data-sticky="top"

            >

            </group>
            <group data-height="autofit">
              <picture data-position="absolute" data-object-fit='cover'><img src={sampleImage7} alt="" /></picture>
              <group
                data-direction="column"
                data-justify="center"
                data-align="center"
              >
                <group
                  data-background="main"
                  data-radius="20"
                  data-radius-bottom-left="0"
                  data-radius-bottom-right="0"
                  data-space="30"
                  data-min-length="240"
                  data-length="450"
                  data-height="300"
                  data-contain=""
                  data-direction="column"
                  data-align="center"
                  data-justify="center"
                  data-gap="20"
                  data-dark=""

                  data-position="absolute"
                  data-right="100"
                  data-bottom="100"
                >
                  <group data-gap="10" data-align="center">
                    <text data-weight="500" data-text-size="x-large" data-wrap="wrap">
                      Bienvenue sur PROJI-PAC 4
                    </text>
                  </group>

                  <text data-wrap="wrap" data-line="1.5">
                    Nam maximus ante eu arcu mollis rhoncus. Nulla volutpat
                    fringilla ante. Mauris hendrerit tristique sagittis. Cras
                    egestas dapibus risus non aliquet.
                  </text>
                </group>
              </group>
            </group>
          </view>
        </view>
      </view>


      <group data-name="switch-gap" data-shrink="no"></group>
    </view>
  );
};
export default Main;
